import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-staff-layout.component.html'
})
export class FullStaffLayoutComponent { }



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/containers/full-staff-layout/full-staff-layout.component.ts